
import React,{Component} from 'react';
import './PhoneAddPage.css';
import {connect} from 'react-redux';
import {getIntValue, getStrValue, isObjEmpty} from "../../utils/common";
import {fetchPost, fetchGet, fetchGetNoSession} from '../../utils/fetchRequest';
import {_baseURL, API} from '../../configs/api.config';
import {Button} from 'antd';
import {Toast, Picker, List, DatePicker} from 'antd-mobile';
import PhoneItem from './PhoneItem';

class PhoneAddPage extends Component{
    constructor(props){
        super(props);
        this.state = {
            selectContentArray: [
                {
                    parentsName:null,
                    phone:null,
                    relation:null,
                }
            ],
        }
    }
    componentWillMount() {
        document.title = "添加家长号码";
    }
    componentDidMount() {

    }
    render(){

        return(
        <div className='common-column-layout' onChange={this.handelValueCom} style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}}>
            <div ref={node => this.node = node} style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}} className="common-column-layout">
                <div style={{padding:10}}>
                    <div style={{backgroundColor:'#FFF',width:'100%',padding:10,borderRadius:10}}>
                        <div className="leave_row_sty">
                            <div>
                                {this.state.selectContentArray.map((itemata,index) => <PhoneItem index ={index} itemata = {itemata} handelRItem={this.handelRItem} removeSItem={this.removeSItem}></PhoneItem>)}
                                <div onClick={this.addPhoneItem} className="text-center" style={{color:"#0CE11D",fontSize:12,margin:10}}>+ <span style={{color:"#666666",borderBottom:"1px #000 solid"}}>添加家长号码</span></div>
                            </div>
                        </div>
                        {/*<div>
                            <div onClick={this.onSubmitClick} className="text-center" style={{color:"#0CE11D",fontSize:30,margin:10}}><span style={{borderBottom:"1px #000 solid"}}>保存</span></div>
                        </div>*/}
                    </div>
                </div>
            </div>
            <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                            onClick={this.onSubmitClick}>提交</Button>
        </div>
        )
    }

    onSubmitClick = () => {
        if(this.isRequesting == true){
            return
        }
        console.log('state',this.state)
        for(let i=0;i<this.state.selectContentArray.length;i++){
            if (this.state.selectContentArray[i].phone == null || this.state.selectContentArray[i].phone.trim().length == 0){
                Toast.show('电话明细存在未输入项')
                return
            }
        }

        var params = {
            schoolId: this.props.userInfo.user.schoolId,
            stuId: this.props.userInfo.parent.student.stuId,
            parentsDOS:this.state.selectContentArray
        }
        this.isRequesting = true
        fetchPost(API.PARENT_PHONE_CREATED, {
            dataString:JSON.stringify(params)
        }, {}).then((response) => {
            console.log('response', response)
            this.isRequesting = false
            if (response.success) {
                this.isRequesting = true
                Toast.show(response.data, 1)
                this.backTask = setTimeout(() => {
                    this.props.history.goBack()
                }, 1000)
            }
        }).catch((error) => {
            this.isRequesting = false
            console.log('error', error)
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    removeSItem = (index)=>{
        if(this.state.selectContentArray.length == 1){
            return
        }
        let selectContentArray = this.state.selectContentArray
        selectContentArray.splice(index,1)
        this.setState({
            selectContentArray
        })
    }

    handelRItem = (itemObject,index)=>{
        console.log('itemObject',itemObject)
        console.log('index',index)
        let selectContentArray = this.state.selectContentArray
        selectContentArray[index] = itemObject
        this.setState({
            selectContentArray:selectContentArray
        })
    }

    addPhoneItem = (event)=>{
        let selectContentArray =  [...this.state.selectContentArray,1];
        this.setState({
            selectContentArray
        })
    }

}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PhoneAddPage)